import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noValueTextExperiment: {
		id: 'issue-field-story-point-estimate-readview-full.story-point-estimate.no-value-text-experiment',
		defaultMessage: 'Add story points',
		description: 'Message when the field has no value',
	},
});
